export default __webpack_public_path__ + "static/media/WhiteHome.66994dbe.svg";